const initialState = {
    uploadFileData: "",
    serviceId: "",
    categoryData: {
        projectName: "",
        categoryId: "",
    },
    subCategoryIds: "",
    emailOTPData: "",
    roleData: {
        role: "",
    },
    registrationData: {
        fullname: '',
        email: '',
        password: '',
        confirmPassword: '',
        phone: '',
        companyName: "",
        collegeName: "",
        companyAddress: '',
        collegeAddress: "",
        termsAndConditions: false,
        pricing: "",
    },
    billingAddressData: {
        // selectedOption: '',
        addressData: '',
    },
    projectID: "",
    materialReportData: "",
    costingReportData: "",
    materialReportStatusData: "",
    costingReportStatusData: "",
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'UPDATE_PROJECT_ID':
            return {
                ...state,
                projectID: action.payload
            };
        case 'UPDATE_MATERIAL_REPORT_DATA':
            return {
                ...state,
                materialReportData: action.payload
            };
        case 'UPDATE_COSTING_REPORT_DATA':
            return {
                ...state,
                costingReportData: action.payload
            };
        case 'UPDATE_MATERIAL_STATUS_DATA':
            return {
                ...state,
                materialReportStatusData: action.payload
            };
        case 'UPDATE_COSTING_STATUS_DATA':
            return {
                ...state,
                costingReportStatusData: action.payload
            };
        case 'UPDATE_UPLOAD_DATA':
            return {
                ...state,
                uploadFileData: action.payload,  // directly assigning the URL string
            };
        case 'UPDATE_SUBCATEGORY_IDS':
            return {
                ...state,
                subCategoryIds: action.payload,  // directly assigning the URL string
            };
        case 'SEND_EMIAL_OTP_DATA':
            return {
                ...state,
                emailOTPData: action.payload,  // directly assigning the URL string
            };
        case 'UPDATE_SERVICE_ID':
            return {
                ...state,
                serviceId: action.payload,  // directly assigning the URL string
            };
        case 'UPDATE_CATEGORY_DATA':
            return {
                ...state,
                categoryData: {
                    ...state.categoryData, // Keep existing user type data
                    ...action.payload, // Update with new payload values
                },
            };
        case 'UPDATE_ROLE_DATA':
            return {
                ...state,
                roleData: {
                    ...state.roleData, // Keep existing user type data
                    ...action.payload, // Update with new payload values
                },
            };
        case 'UPDATE_REGISTRATION_DATA':
            return {
                ...state,
                registrationData: {
                    ...state.registrationData, // Keep existing registration data
                    ...action.payload, // Update with new payload values
                },
            };
        case 'UPDATE_BILLING_ADDRESS_DATA':
            return {
                ...state,
                billingAddressData: {
                    ...state.billingAddressData, // Keep existing billing data
                    ...action.payload, // Update with new payload values
                },
            };
        default:
            return state;
    }
};

export default reducer;
